export const RATING = [5, 4, 3, 2, 1, 0];

export const MIN_DISTANCE = 5;

export const formatWavePeriodValue = (dateValue = new Date()) => {
  return `${dateValue.getFullYear()}${
    dateValue.getMonth() + 1 >= 10
      ? dateValue.getMonth() + 1
      : `0${dateValue.getMonth() + 1}`
  }`;
};

export const DEFAULT_STATS_TABS = ['DAILY', 'MONTHLY', 'WAVE'];

export const CHANNEL_TYPES = {
  Short: 0,
  Long: 1,
};

export const formatThousands = (num) => {
  if (!num) return '0';
  return num.toLocaleString()?.replace(',', '.');
};
